import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "sidebar-app" }
const _hoisted_2 = { class: "p-sidebar-mask p-sidebar-visible p-sidebar-left app-sidebar-style" }
const _hoisted_3 = { class: "p-sidebar p-component p-ripple-disabled app-sidebar" }
const _hoisted_4 = { class: "flex align-items-center p-2" }
const _hoisted_5 = { class: "flex align-items-center justify-content-between cursor-pointer p-3 border-round transition-duration-150 transition-colors p-ripple user-profil w-full" }
const _hoisted_6 = { class: "flex flex-column h-full" }
const _hoisted_7 = { class: "overflow-y-auto" }
const _hoisted_8 = { class: "list-none p-3 m-0 overflow-hidden" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_navlink = _resolveComponent("navlink")!
  const _directive_ripple = _resolveDirective("ripple")!
  const _directive_styleclass = _resolveDirective("styleclass")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _withDirectives((_openBlock(), _createElementBlock("a", _hoisted_5, [
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "flex align-items-center" }, [
              _createElementVNode("img", {
                src: "https://cdn.create.vista.com/api/media/small/295488734/stock-photo-modern-african-american-ceo-portrait-standing-confidently-arms-crossed-swanky",
                alt: "",
                class: "avatar mr-3"
              }),
              _createElementVNode("span", { class: "font-medium" }, "Amy Elsner")
            ], -1)),
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
              class: "w-full p-link flex align-items-center ml-4 p-2 pl-4 text-color hover:surface-200 border-noround"
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("span", { class: "material-icons icon-class pr-2" }, "logout", -1)
            ]))
          ])), [
            [_directive_ripple],
            [_directive_styleclass, {
                            selector: '@next',
                            enterClass: 'hidden',
                            enterActiveClass: 'slidedown',
                            leaveToClass: 'hidden',
                            leaveActiveClass: 'slideup'
                        }]
          ])
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("span", { class: "p-hidden-accessible p-hidden-focusable" }, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, [
                  _createVNode(_component_navlink, {
                    title: menu.titleMenu,
                    link: menu.link,
                    icon: menu.icon,
                    subMenus: menu.subMenus,
                    showmenu: _ctx.showmenu,
                    isOpen: _ctx.isOpen
                  }, null, 8, ["title", "link", "icon", "subMenus", "showmenu", "isOpen"])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}